import styled from 'styled-components';

export const PriorityName = styled.span`
    padding-right: 0.3rem;
`;
